var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('router-view',{class:`main-view bg-theme-lightest ${_vm.signedIn ? 'pl-12' : 'px-24'}`}),(_vm.signedIn)?_c('SideNav'):_vm._e(),(_vm.signedIn)?_c('div',{staticClass:"absolute p-3 top-0 right-0 z-50",attrs:{"id":"signout"}},[_c('amplify-sign-out')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }